var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$i18n.locale == 'en' ? '' : 'rtl',attrs:{"id":"nav"}},[_c('Toast'),_c('RouterView')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }